(() => {
  const restoreTextUrls = (root = document) => {
    root.querySelectorAll('.rte a:not([href])').forEach((link) => {
      const value = link.textContent.trim();

      if (/^https?:\/\/\S+$/i.test(value)) {
        link.href = value;
      }
    });

    root.querySelectorAll('.rte img:not([src]):not([srcset])').forEach((image) => image.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => restoreTextUrls());
  } else {
    restoreTextUrls();
  }

  document.addEventListener('shopify:section:load', (event) => restoreTextUrls(event.target));
})();
